import { motion } from "framer-motion";
import { Globe, Smartphone } from "lucide-react";
import AppsWebPage from "../Components/AppsWeb/AppsWebPage";


export default function AppsWebsites() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="p-6"
    >
      <AppsWebPage />
    </motion.div>
  );
}
